import { ContentfulModule, Cta, DocumentWithEmbeddedEntries, MediaAsset, Sys } from 'libs/contentful/types';
import { Colorways, Margins, RoundedCorners } from 'types/constants';
import { SocialMediaLinkProps } from 'types/sharedComponents';

export enum ContentBlockVariants {
  OneColumn = 'One Column',
  TwoColumn = 'Two Column',
  SocialMedia = 'Social Media',
}

export enum ContentBlockAlignment {
  Left = 'Left',
  Right = 'Right',
}

export interface OneColumnClassNames {
  wrapper: string;
  outerContent: string;
  innerContent: string;
  headline: {
    wrapper: string;
    content: string;
  };
  copy: string;
  empty: string;
}

export interface TwoColumnClassNames {
  wrapper: string;
  headline: {
    wrapper: string;
    content: string;
  };
  content: string;
}

export interface SocialMediaItemClassNames {
  wrapper: string;
  icon: string;
  label: string;
}

export interface SocialMediaClassNames {
  wrapper: string;
  headline: string;
  socials: {
    wrapper: string;
    list: string;
    item?: Partial<SocialMediaItemClassNames>;
  };
}

export interface ContentBlockClassNames {
  wrapper: string;
  contentWrapper: string;

  oneColumn?: Partial<OneColumnClassNames>;
  twoColumn?: Partial<TwoColumnClassNames>;
  socialMedia?: Partial<SocialMediaClassNames>;
}

export interface ContentBlockProps extends ContentfulModule {
  sys: Sys;

  variant: ContentBlockVariants;
  margins: Margins;
  color: Colorways;
  roundedCorners?: RoundedCorners;
  eyebrow: DocumentWithEmbeddedEntries;
  eyebrowAlternateLogo?: MediaAsset;
  eyebrowChimeLogo?: boolean;
  headline: DocumentWithEmbeddedEntries;
  copy: DocumentWithEmbeddedEntries;
  cta: Cta;

  socialMedia: {
    items: SocialMediaLinkProps[];
  };

  alignment?: ContentBlockAlignment;

  className?: Partial<ContentBlockClassNames>;
}

export interface OneColumnVariantProps extends Pick<
  ContentBlockProps,
  'sys' | 'eyebrow' | 'eyebrowAlternateLogo' | 'eyebrowChimeLogo' | 'headline' | 'copy' | 'cta' | 'alignment'
> {
  className?: Partial<OneColumnClassNames>;
}

export interface TwoColumnVariantProps extends Pick<
  ContentBlockProps,
  'sys' | 'eyebrow' | 'eyebrowAlternateLogo' | 'eyebrowChimeLogo' | 'headline' | 'copy' | 'cta' | 'alignment'
> {
  className?: Partial<TwoColumnClassNames>;
}

export interface SocialMediaItemProps {
  social: SocialMediaLinkProps;
  className?: Partial<SocialMediaItemClassNames>;
}

export interface SocialMediaVariantProps extends Pick<ContentBlockProps, 'sys' | 'headline' | 'socialMedia'> {
  className?: Partial<SocialMediaClassNames>;
}
